import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTORS_QUERY_KEYS } from "Actors/Api/Queries/queryKeys";
import {
  putActorsActorID,
  type SaveActorRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

interface UpdateActorParams {
  actorID: string;
  data: SaveActorRequest;
}

export function useUpdateActorMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(({ actorID, data }: UpdateActorParams) =>
    putActorsActorID(data, actorID),
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { actorID }) => {
      queryClient.invalidateQueries({
        queryKey: ACTORS_QUERY_KEYS.all,
      });
      queryClient.invalidateQueries({
        queryKey: ACTORS_QUERY_KEYS.detail(actorID),
      });
    },
  });
}
